import { AsyncPipe, CurrencyPipe, NgClass, NgFor, NgIf, NgOptimizedImage } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { CardComponent } from '@components/card/card.component';
import { PaymentCardFormComponent } from '@components/consultation-request/payment-card-form/payment-card-form.component';
import { PaymentSubmitButtonComponent } from '@components/consultation-request/payment-submit-button/payment-submit-button.component';
import { MycoplasmaBaseComponent } from '@components/mycoplasma-base/mycoplasma-base.component';
import { MycoplasmaGenitaliumUpsell } from '@data/tests';
import { MycoplasmaTypes } from '@enums/mycoplasma-types';
import { OrderUpsell } from '@models/order-upsell';
import { ImageFallback } from '@pipes/image-fallback';
import { provideDefaultPaymentConfig } from '@services/payment.service';

@Component({
  selector: 'app-mycoplasma-genitalium',
  templateUrl: '../mycoplasma-base/mycoplasma-base.component.html',
  styleUrls: ['../mycoplasma-base/mycoplasma-base.component.scss', './mycoplasma-genitalium.component.scss'],
  imports: [
    NgIf,
    CardComponent,
    NgFor,
    NgClass,
    PaymentCardFormComponent,
    PaymentSubmitButtonComponent,
    AsyncPipe,
    CurrencyPipe,
    ImageFallback,
    NgOptimizedImage,
  ],
  providers: [provideDefaultPaymentConfig()],
})
export class MycoplasmaGenitaliumComponent extends MycoplasmaBaseComponent implements OnInit {
  public override readonly mycoplasmaTest: OrderUpsell = MycoplasmaGenitaliumUpsell;

  /**
   * Initializes the component.
   *
   * Fetches the Mycoplasma Genitalium content and displays it.
   */
  public ngOnInit(): void {
    this.getMycoplasmaContent(MycoplasmaTypes.Genitalium);
  }
}
